<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/NDvNBV/tc-custom/9781464209642.jpg?1730612300419" alt="This image is the cover for the book Gold Dust, Texas Red River Mysteries"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Gold Dust, Texas Red River Mysteries
      </h1>
      <p class="bookDescription body article font2">
        <p><b>Best of the West 2019 – 2nd Place in 20th- to 21st-Century Western Mystery Fiction by <i>TrueWest </i>Magazine</b></p><p><b>"Wortham's writing style is easygoing, relying on natural-sounding dialogue and vivid descriptions to give us the feeling that this story could well have taken place." —<i>Booklist</i></b></p><p>As the 1960s draw to a close, the rural northeast Texas community of Center Springs is visited by two nondescript government men in dark suits and shades. They say their assignment is to test weather currents and patterns, but that's a lie. Their delivery of a mysterious microscopic payload called Gold Dust from a hired crop duster coincides with fourteen-year-old Pepper Parker's discovery of an ancient gold coin in her dad's possession. Her adolescent trick played on a greedy adult results in the only gold rush in north Texas history. Add in modern-day cattle-rustlers and murderers, and Center Springs is once again the bull's-eye in a deadly target.</p><p>The biological agent deemed benign by the CIA has unexpected repercussions, putting Pepper's near-twin cousin, Top, at death's door. The boy's crisis sends their grandfather, Constable Ned Parker, to Washington D.C. to exact personal justice, joined by a man Ned left behind in Mexico and had presumed dead. The CIA agents who operate on the dark side of the U.S. government find they're no match for men who know they're right and won't stop. Especially two old country boys raised on shotguns.</p><p>But there's more. Lots more. Top Parker thought only he had what had become known as a Poisoned Gift, but Ned suffers his own form of a family curse he must deploy. Plus, there are many trails to follow as the lawmen desperately work to put an end to murder and government experimentation that extends from their tiny Texas town to Austin and, ultimately, to Washington, D.C. Traitors, cattle-rustlers, murderers, rural crime families, grave robbers, CIA turncoats, and gold-hungry prospectors pursue agendas that all, in a sense, revolve around the center of this small vortex called Center Springs.</p><p><i>Gold Dust</i> seems to be fiction, but the truth is, it has already happened.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Reavis Z. Wortham
      </h2>
      
      <p class="authorDescription body article"><P>Reavis Z. Wortham is the critically acclaimed author of the Red River Mysteries set in rural Northeast Texas in the 1960s. As a boy, he hunted and fished the river bottoms near Chicota, the inspiration for the fictional location. He is also the author of a thriller series featuring Texas Ranger Sonny Hawke. He teaches writing at a wide variety of venues including local libraries and writers' conferences. Wortham has been a newspaper columnist and magazine writer since 1988, and has been the Humor Editor for Texas Fish and Game Magazine for the past twenty-two years. He and his wife, Shana, live in Northeast Texas. Check out his website at www.reaviszwortham.com</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Poisoned Pen Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?bdc8f3c6